// EditPassword.js
import React from "react";
import EditPasswordTemplate from "./components/templates/editPasswordTemplate";

export default function EditPassword() {
  return <EditPasswordTemplate />;
}